import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import DoctorReviewCard from "./DoctorReviewCard";
import Loading from "../../Shared/Loading";

const DoctorReviews = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://servercareseebd.careseebd.com/api/v1/doctorReview/getdoctorReview`)
      .then((r) => r.json())
      .then((d) => { if (d?.data?.length) setDoctors(d.data); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <section className="section-py bg-dark-gradient overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Centered header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 bg-white/10 text-indigo-300 border border-white/10 rounded-full px-4 py-1 text-xs font-semibold uppercase tracking-widest mb-5">
            <Icon icon="solar:star-bold" className="w-3.5 h-3.5" />
            Testimonials
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
            Trusted by Doctors
            <br />
            <span className="text-gradient">Across Bangladesh</span>
          </h2>
          <p className="mt-5 text-base text-gray-400 max-w-lg mx-auto">
            Hear directly from the specialists who use Medmyne every day to deliver better patient outcomes.
          </p>

          {/* Aggregate rating */}
          <div className="mt-6 inline-flex items-center gap-2 bg-white/8 border border-white/10 rounded-full px-5 py-2">
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map((s) => (
                <Icon key={s} icon="solar:star-bold" className="w-3.5 h-3.5 text-amber-400" />
              ))}
            </div>
            <span className="text-sm font-semibold text-white">5.0</span>
            <span className="text-xs text-gray-400">avg. doctor rating</span>
          </div>
        </div>

        {/* Horizontal scroll-snap carousel */}
        <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 scrollbar-hide">
          {doctors.length > 0 ? (
            doctors.map((doc) => <DoctorReviewCard key={doc._id} doctor={doc} />)
          ) : (
            <p className="text-sm text-gray-400 py-10 text-center w-full">
              No reviews yet.
            </p>
          )}
        </div>

        {/* Indicator dots */}
        {doctors.length > 0 && (
          <div className="flex justify-center gap-1.5 mt-8">
            {doctors.slice(0, Math.min(doctors.length, 8)).map((_, i) => (
              <span
                key={i}
                className={`rounded-full transition-all duration-200 ${i === 0 ? "w-5 h-1.5 bg-indigo-400" : "w-1.5 h-1.5 bg-white/20"
                  }`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default DoctorReviews;
